export default __webpack_public_path__ + "static/media/Logo_Alfardan.2d3e8582.png";